export const VALIDATION_MESSAGES = {
  IS_MISSING: 'blank',
  CANNOT_BE_EMPTY: 'empty',
  MUST_BE_GREATER_THAN_ZERO: 'greater_than_zero',
  MUST_BE_VALID: 'invalid',
} as const;

export const validateAmount = (amount: unknown): string[] => {
  if (amount === null || amount === undefined) {
    return [VALIDATION_MESSAGES.IS_MISSING];
  }

  if (amount === '') {
    return [VALIDATION_MESSAGES.CANNOT_BE_EMPTY];
  }

  if (typeof amount === 'boolean') {
    return [VALIDATION_MESSAGES.MUST_BE_VALID];
  }

  if (typeof amount === 'string') {
    if (amount.trim() === '') {
      return [VALIDATION_MESSAGES.CANNOT_BE_EMPTY];
    }

    const numericAmount = Number(amount);
    if (isNaN(numericAmount)) {
      return [VALIDATION_MESSAGES.MUST_BE_VALID];
    }

    if (numericAmount <= 0) {
      return [VALIDATION_MESSAGES.MUST_BE_GREATER_THAN_ZERO];
    }

    return [];
  }

  if (typeof amount === 'number') {
    if (isNaN(amount)) {
      return [VALIDATION_MESSAGES.MUST_BE_VALID];
    }

    if (amount <= 0) {
      return [VALIDATION_MESSAGES.MUST_BE_GREATER_THAN_ZERO];
    }

    return [];
  }

  return [VALIDATION_MESSAGES.MUST_BE_VALID];
};
